import { Box, Typography } from '@mui/material';
import React from 'react';
import Icon from '../../Assets/Icon/CustomIcon';

const badgeColors = {
  gray: {
    background: '#F1F5F9',
    color: '#475569',
  },
  orange: {
    background: '#FFFBEB',
    color: '#D97706',
  },
  blue: {
    background: '#EFF6FF',
    color: '#2563EB',
  },
  red: {
    background: '#FFF1F2',
    color: '#E11D48',
  },
  green: {
    background: '#ECFDF5',
    color: '#059669',
  },
  whiteGreen: {
    background: '#ECFEFF',
    color: '#0891B2',
  },
  deepOrange: {
    background: '#FFF7ED',
    color: '#EA580C',
  },
  indigo: {
    background: '#EEF2FF',
    color: '#4F46E5',
  },
  purple: {
    background: '#FAF5FF',
    color: '#9333EA',
  },
  pink: {
    background: '#FDF2F8',
    color: '#DB2777',
  },
  yellow: {
    background: '#FEFCE8',
    color: '#CA8A04',
  },
};

const colorPool = [
  'gray',
  'blue',
  'green',
  'purple',
  'red',
  'orange',
  'whiteGreen',
  'pink',
  'indigo',
  'deepOrange',
  'yellow',
];

const labelColorMap = {
  사업주: 'purple',
  본사관리자: 'whiteGreen',
  근로자: 'blue',
  직함없음: 'gray',
  시스템관리자: 'pink',
};
const dynamicColorCache = {};
let nextPoolIndex = 0;

function getStableColorKey(label) {
  const trimmedLabel = label?.trim() || '직함없음';

  if (labelColorMap[trimmedLabel]) {
    return labelColorMap[trimmedLabel];
  }

  if (dynamicColorCache[trimmedLabel]) {
    return dynamicColorCache[trimmedLabel];
  }

  const assignedColor = colorPool[nextPoolIndex % colorPool.length];
  dynamicColorCache[trimmedLabel] = assignedColor;

  nextPoolIndex++;

  return assignedColor;
}

export function Badge({ authCd = '', label = '', onClick = () => {} }) {
  const authCdLabelMap = {
    BUSINESS_OWNER: '사업주',
    HEAD_MANAGER: '본사관리자',
    EMPLOYEE: '근로자',
    ADMIN: '시스템관리자',
  };
  const resolvedLabel = label || authCdLabelMap[authCd] || '직함없음';
  const colorKey = getStableColorKey(resolvedLabel);
  const colors = badgeColors[colorKey] || badgeColors.gray;

  const ClickButton = (e) => {
    onClick(e);
  };

  return (
    <>
      <Box
        sx={{
          height: '20px',
          px: '8px',
          display: ' flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '5px',
          backgroundColor: colors.background,
          color: colors.color,
          fontWeight: '600',
          fontSize: '12px',
        }}
        onClick={ClickButton}
      >
        {resolvedLabel}
      </Box>
    </>
  );
}

export function ConstructionBadge({ label = '', onClick = () => {} }) {
  const colorKey = getStableColorKey(label);
  const colors = badgeColors[colorKey] || badgeColors.default;

  const ClickButton = (e) => {
    onClick(e);
  };

  return (
    <>
      <Box
        sx={{
          pl: '10px',
          pr: '6px',
          display: ' flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '15px',
          backgroundColor: colors.background,
          color: colors.color,
          fontWeight: '600',
          fontSize: '12px',
        }}
        onClick={ClickButton}
      >
        <Typography
          sx={{
            fontSize: '12px',
          }}
        >
          {label}
        </Typography>
        <button
          style={{
            all: 'unset',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '22px',
            height: '22px',
          }}
        >
          <Icon.Delete />
        </button>
      </Box>
    </>
  );
}
